import { Chip, Tooltip } from '@mui/material'
import { FC, useMemo } from 'react'
import {
  useRecordContext,
  useTranslate,
} from 'react-admin'
import { CertificateOut } from '../../types/apiRequests'

const msPerDay = 1000 * 60 * 60 * 24

const ValidityChip: FC = () => {
  const record = useRecordContext<CertificateOut>()
  const translate = useTranslate()
  const { days, bgColor, description } = useMemo(() => {
    if (!record?.verloopDatum) {
      return {
        days: '—',
        color: 'default' as const,
        tooltip: translate('resources.certificates.fields.noExpiry', { _: 'Geen verloopdatum' }),
      }
    }

    const now = new Date()
    const expiry = new Date(record.verloopDatum)
    const diff = Math.ceil((expiry.getTime() - now.getTime()) / msPerDay)

    const title = expiry.toLocaleString(undefined, { dateStyle: 'long', timeStyle: 'short' })
    const tooltip =
      diff < 0
        ? translate('resources.certificates.tooltips.expiredOn', { date: title, _: `Verlopen op ${title}` })
        : translate('resources.certificates.tooltips.expiresOn', { date: title, _: `Verloopt op ${title}` })

    let color: 'error' | 'warning' | 'success'
    if (diff < 0) {
      color = 'error'
    } else if (diff <= 60) {
      color = 'warning'
    } else {
      color = 'success'
    }

    return { days: diff < 0 ? `-${Math.abs(diff)}` : `${diff}`, bgColor: color, description: tooltip }
  }, [record, translate])

  return (
    <Tooltip title={description}>
      <Chip
        label={typeof days === 'string' ? days : `${days as string}`}
        color={bgColor}
        variant='outlined'
        size="small"
        sx={{ minWidth: 32, justifyContent: 'center', fontSize: '0.6rem' }}
      />
    </Tooltip>
  )
}

export default ValidityChip